import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DatePipe } from "@angular/common";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-flow-issues-dialog",
  templateUrl: "./flow-issues-dialog.component.html",
  styleUrls: ["./flow-issues-dialog.component.scss"],
})
export class FlowIssuesDialogComponent implements OnInit {
  flowData: any;
  issues: any[] = [];
  userData: any;
  isFlowOwner: boolean = false;
  // Optional: issue RowKey to visually highlight when opening the dialog
  highlightedIssueRowKey?: string | null;
  issueResponseText: Map<string, string> = new Map();

  constructor(
    public dialogRef: MatDialogRef<FlowIssuesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private datePipe: DatePipe,
    private flowServiceService: FlowServiceService,
    private toastr: ToastrService
  ) {
    this.flowData = data.flowData;
    this.issues = data.issues || [];
    this.userData = data.userData;
    this.isFlowOwner = data.isFlowOwner || false;
    this.highlightedIssueRowKey = data.highlightedIssueRowKey || null;
  }

  ngOnInit(): void {
    // Sort issues by date (newest first)
    this.issues.sort((a, b) => {
      const dateA = new Date(a.reviewDate || 0).getTime();
      const dateB = new Date(b.reviewDate || 0).getTime();
      return dateB - dateA;
    });
  }

  formatDate(date: any): string {
    if (!date) return '';
    return this.datePipe.transform(date, 'MMMM d, y') || '';
  }

  trackByIssueId(index: number, issue: any): any {
    return issue.rowKey || issue.id || index;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  getIssueResponse(issueRowKey: string): string {
    return this.issueResponseText.get(issueRowKey) || '';
  }

  setIssueResponse(issueRowKey: string, value: string): void {
    this.issueResponseText.set(issueRowKey, value);
  }

  respondToIssue(issue: any): void {
    const response = this.issueResponseText.get(issue.rowKey);
    if (!response || !response.trim()) {
      this.toastr.warning("Please enter a response");
      return;
    }

    this.flowServiceService.respondToIssue(issue.rowKey, response).subscribe(
      (responseData) => {
        this.toastr.success("Response submitted successfully");
        this.issueResponseText.delete(issue.rowKey);
        // Update the issue in the local array
        const issueIndex = this.issues.findIndex(i => i.rowKey === issue.rowKey);
        if (issueIndex !== -1) {
          this.issues[issueIndex].creatorResponse = responseData.creatorResponse;
          this.issues[issueIndex].creatorResponseDate = responseData.creatorResponseDate;
        }
        // Emit event to refresh data in parent component
        this.dialogRef.close({ refresh: true });
      },
      (error) => {
        this.toastr.error("Error submitting response");
        console.error(error);
      }
    );
  }

  moderateIssue(issue: any, status: string): void {
    if (!issue || !issue.rowKey) {
      return;
    }

    this.flowServiceService.moderateIssue(issue.rowKey, status).subscribe(
      (updatedIssue) => {
        if (status === "TakenDown") {
          // Remove from local list so it disappears immediately
          this.issues = this.issues.filter(i => i.rowKey !== issue.rowKey);
        } else {
          // Update local issue status
          const idx = this.issues.findIndex(i => i.rowKey === issue.rowKey);
          if (idx !== -1) {
            this.issues[idx].moderationStatus = updatedIssue.moderationStatus || status;
          }
        }
        this.toastr.success(
          status === "TakenDown" ? "Issue taken down and will no longer appear on the flow." : "Issue marked as resolved."
        );
      },
      (error) => {
        console.error("Error moderating issue", error);
        this.toastr.error("Failed to update issue status. Please try again.");
      }
    );
  }
}

